import { Navigate, Route, Routes } from 'react-router-dom';

import { HeaderGeneral } from '@/components/DybrComponents/HeaderGeneral';
import { NavTab } from '@/components/DybrComponents/NavTab';
import { ServiceBackground } from '@/components/DybrComponents/ServiceBackground';
import TabsContainer from '@/components/DybrComponents/TabsContainer';
import Footer from '@/scenes/Footer/Footer';
import ProfileSettings from '@/scenes/User/Settings/Blog/ProfileSettings/ProfileSettings';
import { BlogSettingsScene } from '@/scenes/User/Settings/Blog/SettingsBlog';
import ProfilePrivacySettings from '@/scenes/User/Settings/PrivacySettings';
import { useTokenState } from '@/store/localStorage/useTokenState';
import { AccountSettings } from './Settings/AccountSettings';
import { CommonSettings } from './Settings/SettingsCommon';

function SettingsPage() {
  const [token] = useTokenState();
  const isLoggedIn = Boolean(token);

  // we do this instead of routing because in case of logout from these pages it is better if user
  // does not see 404 page
  if (!isLoggedIn) {
    return <Navigate replace to="/" />;
  }

  return (
    <ServiceBackground data-testid="settings">
      <HeaderGeneral paddingBottom="45px">
        <h1>настройки</h1>
        <TabsContainer>
          <NavTab to="../common" data-testid="tab-common">
            общие
          </NavTab>
          <NavTab to="../account" data-testid="tab-account">
            аккаунт
          </NavTab>
          <NavTab to="../profile" data-testid="tab-profile">
            профиль
          </NavTab>
          <NavTab to="../privacy" data-testid="tab-privacy">
            приватность
          </NavTab>
          <NavTab to="../blog" data-testid="tab-blog">
            блог
          </NavTab>
        </TabsContainer>
      </HeaderGeneral>

      <Routes>
        <Route path="/" element={<Navigate replace to="common" />} />
        <Route path="common" element={<CommonSettings />} />
        <Route path="account" element={<AccountSettings />} />
        <Route path="profile" element={<ProfileSettings />} />
        <Route path="privacy" element={<ProfilePrivacySettings />} />
        <Route path="blog" element={<BlogSettingsScene />} />
      </Routes>

      <Footer withLemur />
    </ServiceBackground>
  );
}

export default SettingsPage;
